import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectActiveChannel, selectGmlProjectionItems } from 'redux/channels';
import { Wikis24 } from '@carbon/icons-react';
import Utils from 'utilities/helper.util';

export const WebHookActiveChannelComponent: React.FC<any> = () => {
  const gmlProjectionOptions: any = useSelector(selectGmlProjectionItems);
  const activeChannels: any = useSelector(selectActiveChannel);

  const [gmlProjection, setGmlProjection] = useState<string | undefined>('-');
  const [startedLiveAt, setStartedLiveAt] = useState<string | undefined>('-');

  useEffect(() => {
    if (activeChannels && !Utils.isObjectEmpty(activeChannels)) {
      const WebhookConfiguration = activeChannels.WebhookConfiguration;
      const startLiveDate = Utils.toLocalDateTimeFormat(
        activeChannels.startedLiveAt || activeChannels.updatedAt
      );

      startLiveDate && setStartedLiveAt(startLiveDate);
      if (WebhookConfiguration) {
        const selectedGml = gmlProjectionOptions?.filter(
          (item: any) => item.code === WebhookConfiguration?.gmlProjection
        );
        selectedGml && setGmlProjection(selectedGml[0]?.label);
      }
    }
  }, [activeChannels, gmlProjectionOptions]);

  return (
    <>
      <div className="section__top">
        <Wikis24 />
        <div className="section__body">
          <h2 className="section__sub-heading">
            Web hook is your active referral channel
          </h2>
          <p className="section__label">
            Channel types include Email, Web Hook and SmarterWX Automate
          </p>
        </div>
        <hr className="section__divider" />
      </div>

      <div className="section__summary">
        <h4 className="section__sub-heading">Summary</h4>
        <div className="section__sub">
          <div className="section__label">Date activated</div>
          <p className="section__text">{startedLiveAt}</p>
        </div>
        <hr className="section__divider" />

        <div className="section__sub">
          <div className="section__label">Web service URL</div>
          <p className="section__text">
            {activeChannels?.WebhookConfiguration?.WebhookSubscription?.url ||
              '-'}
          </p>
        </div>
        <div className="section__sub">
          <div className="section__label">GIS projection</div>
          <p className="section__text">{gmlProjection}</p>
        </div>
        <hr className="section__divider" />
      </div>
    </>
  );
};
export default WebHookActiveChannelComponent;
